import {readable} from "svelte/store";

export const platformStore = readable(
    {},
    (set) => {
        set ({
            visible: M.paid !== true && M.platform,
            link: (M.platform?.link || '') + M.tenantKey,
            label: M.platform?.label
        });
        return () => {}
    });
